<!-- ================================================ -->
<!-- ReadME -->
<!-- ================================================ -->
<!--
    The Login Widget has currently 7 screens in a single html page. The display has been made more verbose at the expense
    of slightly more code duplication of buttons. This was a trade-off for maintainability, as the original version
    because quite tangled once we had to add mfa, or edit the text on a specific screen.

    The top of the file determins if its in website builder, hosted website, or external website widget mode
    The bottom of the file contains the different screens that the login widget contains.

    For quick access, the screens are tagged:
    #ALI Already Logged In
    #PL Portal Login
    #RP Reset Password
    #RPTY Reset Password Thank You
    #SA Select Account
    #2SV 2-Step Verification
    #MR Manual Redirect
-->

<!-- ================================================ -->
<!-- Widget Switching Logic -->
<!-- ================================================ -->
@if (designBlockMode === DesignBlockMode.Sidebar || designBlockMode === DesignBlockMode.DragPreview) {
    <!-- eslint-disable -->
    @switch (kind) {
        @case (WebsiteBlockLoginFormType.AccentBackgroundDefault) {
            <svg xmlns="http://www.w3.org/2000/svg" data-name="uuid-32519f56-a080-4b99-867e-c507d9981da0" viewBox="0 0 1300 750"><defs><filter id="a" width="398" height="466" x="451.39" y="142.65" data-name="drop-shadow-1" filterUnits="userSpaceOnUse"><feOffset/><feGaussianBlur result="uuid-23902eaa-61ff-4f70-a5b7-b319faef32a1" stdDeviation="8.2"/><feFlood flood-color="#000" flood-opacity=".03"/><feComposite in2="uuid-23902eaa-61ff-4f70-a5b7-b319faef32a1" operator="in"/><feComposite in="SourceGraphic"/></filter></defs><rect width="100%" height="100%" style="fill:var(--block-accent-background-color)"/><path d="M822.85 177.23v395.54c0 5.14-4.16 9.33-9.33 9.33H486.48c-5.16 0-9.35-4.18-9.35-9.33V177.23c0-1.71.46-3.32 1.25-4.68a9.36 9.36 0 0 1 8.09-4.64h327.04c3.47 0 6.48 1.88 8.09 4.68a9.2 9.2 0 0 1 1.23 4.64Z" style="fill:#fff;filter:url(#a);stroke:#e6e5e8;stroke-miterlimit:10"/><text style="fill:#131313;font-family:var(--block-text-heading-font);font-size:32px;font-weight:700;isolation:isolate" transform="translate(568.98 215.09)"><tspan x="0" y="0" style="letter-spacing:-.03em">P</tspan><tspan x="17.54" y="0">o</tspan><tspan x="34.65" y="0" style="letter-spacing:0">r</tspan><tspan x="46.5" y="0">tal Login</tspan></text><rect width="269.38" height="38.7" x="515.6" y="497.3" rx="3.39" ry="3.39" style="fill:var(--block-accent-background-color)"/><text style="fill:#fff;font-family:Inter Variable;font-size:13.44px;font-variation-settings:&quot;wght&quot;700,&quot;slnt&quot;0;font-weight:700;isolation:isolate" transform="translate(630.78 521.33)"><tspan x="0" y="0">Log in</tspan></text><text style="fill:#242229;font-family:Inter Variable;font-size:13.48px;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600" transform="translate(493.43 244.15)"><tspan x="0" y="0">Email</tspan></text><text style="fill:#242229;font-family:Inter Variable;font-size:13.48px;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600" transform="translate(493.43 317.22)"><tspan x="0" y="0">Password</tspan></text><text style="fill:#242229;font-family:Inter Variable;font-size:13.48px;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600" transform="translate(499.93 394.51)"><tspan x="0" y="0">Forgot Password?</tspan></text><text style="fill:#bbb7c1;font-size:13.48px" transform="translate(531.25 453.74)"><tspan x="0" y="0" style="font-family:Inter-Medium,Inter;font-variation-settings:&quot;wght&quot;500,&quot;slnt&quot;0;font-weight:500">I am using </tspan><tspan x="68.87" y="0" style="font-family:Inter Variable;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600">a </tspan><tspan x="79.96" y="0" style="font-family:Inter-Medium,Inter;font-variation-settings:&quot;wght&quot;500,&quot;slnt&quot;0;font-weight:500">public or shared device</tspan></text><rect width="313.09" height="37.8" x="493.73" y="322.33" rx="3.41" ry="3.41" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/><rect width="313.09" height="37.8" x="493.73" y="249.59" rx="3.41" ry="3.41" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/><path d="M493.73 415.91h313.09" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/><rect width="15.96" height="15.96" x="502.8" y="441.28" rx="1.17" ry="1.17" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/></svg>
        }
        @case (WebsiteBlockLoginFormType.Default) {
            <svg xmlns="http://www.w3.org/2000/svg" data-name="uuid-32519f56-a080-4b99-867e-c507d9981da0" viewBox="0 0 1300 750"><defs><filter id="a" width="398" height="466" x="451.4" y="145.65" data-name="drop-shadow-1" filterUnits="userSpaceOnUse"><feOffset/><feGaussianBlur result="uuid-ff171a03-a2bd-44a7-b758-97c02bbb8b23" stdDeviation="8.2"/><feFlood flood-color="#000" flood-opacity=".03"/><feComposite in2="uuid-ff171a03-a2bd-44a7-b758-97c02bbb8b23" operator="in"/><feComposite in="SourceGraphic"/></filter></defs><rect width="100%" height="100%" style="fill:var(--website-background-color)"/><path d="M822.85 180.76V576.3c0 5.14-4.16 9.33-9.33 9.33H486.48c-5.16 0-9.35-4.18-9.35-9.33V180.76c0-1.71.46-3.32 1.25-4.68a9.36 9.36 0 0 1 8.09-4.64h327.04c3.47 0 6.48 1.88 8.09 4.68a9.2 9.2 0 0 1 1.23 4.64Z" style="fill:#fff;filter:url(#a);stroke:#e6e5e8;stroke-miterlimit:10"/><path d="M821.62 176.12a9.3 9.3 0 0 0-8.09-4.68H486.49a9.36 9.36 0 0 0-8.09 4.64c.08-6.48 5.37-11.71 11.88-11.71h319.47c6.52 0 11.81 5.25 11.88 11.75Z" style="fill:var(--block-accent-background-color)"/><text style="fill:#131313;font-family:var(--block-text-heading-font);font-size:32px;font-weight:700;isolation:isolate" transform="translate(568.98 218.62)"><tspan x="0" y="0" style="letter-spacing:-.03em">P</tspan><tspan x="17.54" y="0">o</tspan><tspan x="34.65" y="0" style="letter-spacing:0">r</tspan><tspan x="46.5" y="0">tal Login</tspan></text><rect width="269.38" height="38.7" x="515.6" y="500.83" rx="3.39" ry="3.39" style="fill:var(--block-accent-background-color)"/><text style="fill:#fff;font-family:Inter Variable;font-size:13.44px;font-variation-settings:&quot;wght&quot;700,&quot;slnt&quot;0;font-weight:700;isolation:isolate" transform="translate(630.78 524.86)"><tspan x="0" y="0">Log in</tspan></text><text style="fill:#242229;font-family:Inter Variable;font-size:13.48px;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600" transform="translate(493.43 247.69)"><tspan x="0" y="0">Email</tspan></text><text style="fill:#242229;font-family:Inter Variable;font-size:13.48px;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600" transform="translate(493.43 320.75)"><tspan x="0" y="0">Password</tspan></text><text style="fill:#242229;font-family:Inter Variable;font-size:13.48px;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600" transform="translate(499.93 398.04)"><tspan x="0" y="0">Forgot Password?</tspan></text><text style="fill:#bbb7c1;font-size:13.48px" transform="translate(531.25 457.28)"><tspan x="0" y="0" style="font-family:Inter-Medium,Inter;font-variation-settings:&quot;wght&quot;500,&quot;slnt&quot;0;font-weight:500">I am using </tspan><tspan x="68.87" y="0" style="font-family:Inter Variable;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600">a </tspan><tspan x="79.96" y="0" style="font-family:Inter-Medium,Inter;font-variation-settings:&quot;wght&quot;500,&quot;slnt&quot;0;font-weight:500">public or shared device</tspan></text><rect width="313.09" height="37.8" x="493.73" y="325.86" rx="3.41" ry="3.41" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/><rect width="313.09" height="37.8" x="493.73" y="253.12" rx="3.41" ry="3.41" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/><path d="M493.73 419.44h313.09" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/><rect width="15.96" height="15.96" x="502.8" y="444.82" rx="1.17" ry="1.17" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/></svg>
        }
        @case (WebsiteBlockLoginFormType.MediaLeft) {
            <svg xmlns="http://www.w3.org/2000/svg" data-name="uuid-32519f56-a080-4b99-867e-c507d9981da0" viewBox="0 0 1300 750"><defs><filter id="a" width="561" height="561" x="632.39" y="94.79" data-name="drop-shadow-1" filterUnits="userSpaceOnUse"><feOffset/><feGaussianBlur result="uuid-f3fd642b-6378-412c-a386-a27d301c4e74" stdDeviation="8.2"/><feFlood flood-color="#000" flood-opacity=".03"/><feComposite in2="uuid-f3fd642b-6378-412c-a386-a27d301c4e74" operator="in"/><feComposite in="SourceGraphic"/></filter></defs><rect width="100%" height="100%" style="fill:var(--website-background-color)"/><path d="M133.13 120.68h508.64v508.64H133.13z" style="fill:#d9d9d9"/><g style="isolation:isolate"><path d="M424.27 388.78v24.15c0 2.67-2.16 4.83-4.83 4.83h-28.97c-2.6 0-4.76-2.16-4.76-4.83v-24.15c0-2.67 2.16-4.83 4.76-4.83h28.97c2.73 0 4.83 2.16 4.83 4.83m-33.8 3.62c0 2 1.55 3.62 3.62 3.62s3.62-1.62 3.62-3.62-1.62-3.62-3.62-3.62-3.62 1.62-3.62 3.62m28.84 18.65-9.66-14.49c-.22-.34-.6-.54-1-.54s-.78.2-1 .6l-7.04 10.5-2.45-3.36c-.23-.31-.59-.5-.98-.5s-.75.18-.97.5l-5.28 7.24c-.27.37-.31.85-.1 1.26s.62.66 1.08.66h26.41a1.2 1.2 0 0 0 1-1.87Z" style="fill:#434049"/></g><rect width="509.34" height="508.64" x="657.54" y="120.68" rx="13.96" ry="13.96" style="fill:#fff;stroke:#e6e5e8;stroke-miterlimit:10"/><text style="fill:#242229;font-family:Inter Variable;font-size:13.48px;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600" transform="translate(673.4 243.81)"><tspan x="0" y="0">Email</tspan></text><rect width="476.18" height="37.8" x="673.7" y="248.54" rx="3.41" ry="3.41" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/><text style="fill:#131313;font-family:var(--block-text-heading-font);font-size:32px;font-weight:700;isolation:isolate" transform="translate(830.36 214.07)"><tspan x="0" y="0" style="letter-spacing:-.02em">P</tspan><tspan x="17.54" y="0">o</tspan><tspan x="34.65" y="0" style="letter-spacing:0">r</tspan><tspan x="46.5" y="0">tal Login</tspan></text><text style="fill:#242229;font-family:Inter Variable;font-size:13.48px;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600" transform="translate(680.67 393.9)"><tspan x="0" y="0">Forgot Password?</tspan></text><text style="fill:#242229;font-family:Inter Variable;font-size:13.48px;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600" transform="translate(673.7 316.82)"><tspan x="0" y="0">Password</tspan></text><text style="fill:#bbb7c1;font-size:13.48px" transform="translate(711.52 453.34)"><tspan x="0" y="0" style="font-family:Inter-Medium,Inter;font-variation-settings:&quot;wght&quot;500,&quot;slnt&quot;0;font-weight:500">I am using </tspan><tspan x="68.87" y="0" style="font-family:Inter Variable;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600">a </tspan><tspan x="79.96" y="0" style="font-family:Inter-Medium,Inter;font-variation-settings:&quot;wght&quot;500,&quot;slnt&quot;0;font-weight:500">public or shared device</tspan></text><rect width="475.88" height="37.8" x="674" y="321.92" rx="3.41" ry="3.41" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/><path d="M674 415.5h475.88" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/><rect width="15.96" height="15.96" x="683.07" y="440.88" rx="1.17" ry="1.17" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/><rect width="269.38" height="38.7" x="777.13" y="497.5" rx="3.39" ry="3.39" style="fill:var(--block-accent-background-color)"/><text style="fill:#fff;font-family:Inter Variable;font-size:13.44px;font-variation-settings:&quot;wght&quot;700,&quot;slnt&quot;0;font-weight:700;isolation:isolate" transform="translate(892.31 521.54)"><tspan x="0" y="0">Log in</tspan></text></svg>
        }
        @case (WebsiteBlockLoginFormType.MediaRight) {
            <svg xmlns="http://www.w3.org/2000/svg" data-name="uuid-32519f56-a080-4b99-867e-c507d9981da0" viewBox="0 0 1300 750"><defs><filter id="a" width="562" height="561" x="107.4" y="94.79" data-name="drop-shadow-1" filterUnits="userSpaceOnUse"><feOffset/><feGaussianBlur result="uuid-e5b0b389-2b1f-405e-9b94-ee296161f36c" stdDeviation="8.2"/><feFlood flood-color="#000" flood-opacity=".03"/><feComposite in2="uuid-e5b0b389-2b1f-405e-9b94-ee296161f36c" operator="in"/><feComposite in="SourceGraphic"/></filter></defs><rect width="100%" height="100%" style="fill:var(--website-background-color)"/><rect width="509.34" height="508.64" x="133.34" y="120.68" rx="13.96" ry="13.96" style="fill:#fff;stroke:#e6e5e8;stroke-miterlimit:10"/><text style="fill:#242229;font-family:Inter variable;font-size:13.48px;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600" transform="translate(149.19 243.81)"><tspan x="0" y="0">Email</tspan></text><rect width="476.18" height="37.8" x="149.49" y="248.54" rx="3.41" ry="3.41" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/><path d="M658.02 120.68h508.64v508.64H658.02z" style="fill:#d9d9d9"/><path d="M931.74 352.82v24.14c0 2.67-2.16 4.83-4.83 4.83h-28.97c-2.6 0-4.76-2.16-4.76-4.83v-24.14c0-2.67 2.16-4.83 4.76-4.83h28.97c2.73 0 4.83 2.16 4.83 4.83m-33.8 3.62c0 2 1.55 3.62 3.62 3.62s3.62-1.62 3.62-3.62-1.62-3.62-3.62-3.62-3.62 1.62-3.62 3.62m28.84 18.64-9.66-14.49c-.22-.34-.6-.54-1-.54s-.78.2-1 .6l-7.04 10.5-2.45-3.36c-.23-.31-.59-.5-.98-.5s-.75.18-.97.5l-5.28 7.24c-.27.37-.31.85-.1 1.26s.62.66 1.08.66h26.41a1.2 1.2 0 0 0 1-1.87Z" style="fill:#434049"/><text style="fill:#131313;font-family:var(--block-text-heading-font);font-size:32px;font-weight:700;isolation:isolate" transform="translate(306.15 214.07)"><tspan x="0" y="0" style="letter-spacing:-.02em">P</tspan><tspan x="17.54" y="0">o</tspan><tspan x="34.65" y="0" style="letter-spacing:0">r</tspan><tspan x="46.5" y="0">tal Login</tspan></text><text style="fill:#242229;font-family:Inter Variable;font-size:13.48px;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600" transform="translate(156.46 393.89)"><tspan x="0" y="0">Forgot Password?</tspan></text><text style="fill:#242229;font-family:Inter Variable;font-size:13.48px;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600" transform="translate(149.49 316.82)"><tspan x="0" y="0">Password</tspan></text><text style="fill:#bbb7c1;font-size:13.48px" transform="translate(187.31 453.34)"><tspan x="0" y="0" style="font-family:Inter-Medium,Inter;font-variation-settings:&quot;wght&quot;500,&quot;slnt&quot;0;font-weight:500">I am using </tspan><tspan x="68.87" y="0" style="font-family:Inter Variable;font-variation-settings:&quot;wght&quot;600,&quot;slnt&quot;0;font-weight:600">a </tspan><tspan x="79.96" y="0" style="font-family:Inter-Medium,Inter;font-variation-settings:&quot;wght&quot;500,&quot;slnt&quot;0;font-weight:500">public or shared device</tspan></text><rect width="475.88" height="37.8" x="149.79" y="321.92" rx="3.41" ry="3.41" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/><path d="M149.79 415.5h475.88" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/><rect width="15.96" height="15.96" x="158.87" y="440.88" rx="1.17" ry="1.17" style="fill:none;stroke:#e6e5e8;stroke-miterlimit:10"/><rect width="269.38" height="38.7" x="252.93" y="497.5" rx="3.39" ry="3.39" style="fill:var(--block-accent-background-color)"/><text style="fill:#fff;font-family:Inter Variable;font-size:13.44px;font-variation-settings:&quot;wght&quot;700,&quot;slnt&quot;0;font-weight:700;isolation:isolate" transform="translate(368.1 521.54)"><tspan x="0" y="0">Log in</tspan></text></svg>
        }
    }
    <!-- eslint-enable -->
} @else {
    <div [ngClass]="{
            'scss-website-background-color-only': kind !== WebsiteBlockLoginFormType.AccentBackgroundDefault,
            'scss-block-background-color-variable': kind === WebsiteBlockLoginFormType.AccentBackgroundDefault
        }">

        @if (Scope.websiteMode === WebsiteMode.ReadOnly) {
            <div  class="d-flex position-relative design-block">
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </div>
        }

        @if (Scope.websiteMode === WebsiteMode.Live && Scope.renderContext.RenderMode === WebsiteRenderMode.Website) {
            <div class="widget-block-live">
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </div>
        }

        @if (Scope.websiteMode === WebsiteMode.Live && Scope.renderContext.RenderMode === WebsiteRenderMode.Widget) {
            <div class="d-flex flex-column w-100 h-100 justify-content-center widget-block-live">
                <ng-container *ngTemplateOutlet="widgetBlockContent"></ng-container>
            </div>
        }

        @if (Scope.websiteMode === WebsiteMode.Preview) {
            <lib-design-blocks-action-menu>
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </lib-design-blocks-action-menu>
        }
    </div>
}

<ng-template #blockContent>
    <div class="v3 d-flex flex-row w-100 justify-content-center py-5 widget-block">
        <div class="scss-spacing-widget-block align-items-center"
            [ngClass]="{
            'd-flex flex-sm-row flex-column scss-widget-block-height': kind !== WebsiteBlockLoginFormType.Default,
            'p-3 scss-widget-border shadow-sm scss-spacing-widget-block-no-media background-base-0': kind !== WebsiteBlockLoginFormType.MediaLeft && kind !== WebsiteBlockLoginFormType.MediaRight,
            'scss-spacing-widget-block-media': kind === WebsiteBlockLoginFormType.MediaLeft || kind === WebsiteBlockLoginFormType.MediaRight,
            'scss-spacing-widget-block-accent': kind === WebsiteBlockLoginFormType.AccentBackgroundDefault,
            'scss-sizing-login-widget-block-desktop': (kind !== WebsiteBlockLoginFormType.MediaLeft && kind !== WebsiteBlockLoginFormType.MediaRight) && !isMobile,
            'w-100 mx-3': isMobile,
            'scss-spacing-widget-block-top-border': kind === WebsiteBlockLoginFormType.Default
            }">

            <div class="d-flex flex-column w-100 h-100 justify-content-center">
                <ng-container *ngTemplateOutlet="loginFormContent"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #loginFormContent>
    <div class="d-flex w-100 h-100 justify-content-center gap-3 scss-widget-block-content-container"
        [ngClass]="{
            'flex-row ': (!isMobileOrTablet || designBlockMode === DesignBlockMode.Sidebar) && kind !== WebsiteBlockLoginFormType.MediaRight,
            'flex-column align-items-center': isMobileOrTablet && designBlockMode !== DesignBlockMode.Sidebar,
            'flex-row-reverse ': (!isMobileOrTablet || designBlockMode === DesignBlockMode.Sidebar) && kind === WebsiteBlockLoginFormType.MediaRight
        }">
        @if (kind === WebsiteBlockLoginFormType.MediaLeft || kind === WebsiteBlockLoginFormType.MediaRight) {
            <div class="shadow-sm widget-media-image"
                [ngClass]="{
                    'scss-sizing-widget-block-desktop-media': !isMobile,
                    'w-100': isMobile
                }"
                websiteBlockImage
                [websiteMode]="Scope.websiteMode">

                <lib-image-action-menu></lib-image-action-menu>
                <ng-content select="[image]"></ng-content>
            </div>
        }

        <div class="d-flex flex-column w-100 h-100 justify-content-center background-base-0"
            [ngClass]="{
                'p-3 scss-widget-border shadow-sm': kind === WebsiteBlockLoginFormType.MediaLeft || kind === WebsiteBlockLoginFormType.MediaRight,
                'w-100': kind !== WebsiteBlockLoginFormType.MediaLeft && kind !== WebsiteBlockLoginFormType.MediaRight,
                'scss-sizing-widget-block-desktop-media': (kind === WebsiteBlockLoginFormType.MediaLeft || kind === WebsiteBlockLoginFormType.MediaRight) && !isMobile
            }">

            @if (Scope.websiteMode !== WebsiteMode.Live) {
                <ng-container *ngTemplateOutlet="loginFormFormContent"></ng-container>
            }

            @if (Scope.websiteMode=== WebsiteMode.Live) {
                <iframe #iframe style="min-height: 347px; transition: height .1s" class="w-100" frameBorder="0" scrolling="no" [src]="websiteBlockData.Url + '&sandboxed=false' ! | trustUrl" (load)="Load(iframe)"></iframe>
            }
        </div>
    </div>
</ng-template>

<ng-template #widgetBlockContent>
    <div class="d-flex w-100 h-100 justify-content-center">
        <div class="d-flex flex-column w-100 h-100 justify-content-center background-base-0 base-300 p-3">
            <ng-container *ngTemplateOutlet="loginFormFormContent"></ng-container>
        </div>
    </div>
</ng-template>

<!-- ================================================ -->
<!-- The screens of the actual login widget -->
<!-- ================================================ -->
<ng-template #loginFormFormContent>

    <!-- ================================================ -->
    <!-- #ALI Already Logged In -->
    <!-- ================================================ -->
    @if (loginFormMode === LoginFormMode.AlreadyLoggedIn) {

        <!-- TODO: Unlocked Padlock Icon Here -->

        <h1 [ngClass]="{'align-self-center': true}" class="mb-2 scss-website-block-customized-heading-font"
            i18n="@@LoginWidgetPortalLoginTitle">
            Portal Login
        </h1>

        @if (portalType === PortalType.StudentPortal) {
            <!-- TODO: New Text -->
            <p class="text-center scss-website-block-customized-body-font" i18n="@@LoginWidgetStudentPortalWelcomeBackMessage">
                Welcome back {{alreadyLoggedInFirstName}}! You're already logged in to {{alreadyLoggedInSchoolName}}. Click below to access the #student# portal.
            </p>
        }
        @if (portalType === PortalType.TeacherPortal) {
            <!-- TODO: New Text -->
            <p class="text-center scss-website-block-customized-body-font" i18n="@@LoginWidgetTeacherPortalWelcomeBackMessage">
                Welcome back {{alreadyLoggedInFirstName}}! You're already logged in to {{alreadyLoggedInSchoolName}}. Click below to access the #teacher# portal.
            </p>
        }

        <div class="d-flex flex-column w-100 pt-2">
            <lib-button
                class="scss-widget-primary-btn-accent-color"
                [stretch]="true"
                [loading]="apiInProgress"
                [disabled]="apiInProgress"
                [isViewOnly]="isViewOnly"
                [size]="ButtonSize.Large"
                (clicked)="ReturnToPortal()">
                <ng-container label i18n="@@CommonGoToPortalButton">Go to Portal</ng-container>
            </lib-button>
        </div>

        <div class="d-flex w-100 pt-3 login-widget-link-btn"
            [ngClass]="{
            'justify-content-center': !isMobile,
            'flex-row': !isMobile,
            'flex-column': isMobile
            }">
            <!-- single-column-row -->
            <div>
                <lib-button
                    [kind]="ButtonKind.Link"
                    [stretch]="true"
                    [disabled]="apiInProgress"
                    [isViewOnly]="isViewOnly"
                    [size]="ButtonSize.Large"
                    (clicked)="Logout()">
                    <ng-container label i18n="@@LoginWidgetUseAnotherAccountButtonText">Use Another Account</ng-container>
                </lib-button>
            </div>
        </div>
    }

    <!-- ================================================ -->
    <!-- #PL Portal Login -->
    <!-- ================================================ -->
    @if (loginFormMode === LoginFormMode.Normal) {
        <h1 [ngClass]="{'align-self-center': true}" class="mb-2 scss-website-block-customized-heading-font"
            i18n="@@LoginWidgetPortalLoginTitle">
            Portal Login
        </h1>

        <form [formGroup]="loginForm">
                <lib-input-text [formControl]="loginForm.controls.EmailAddress"
                    [maxCharacterLength]="190"
                    [errorMessages]="emailError"
                    [isOptional]="false"
                    [showRequiredIndicator]="false"
                    data-clarity-mask="true">
                    <ng-container label i18n="@@CommonEmail">
                        Email
                    </ng-container>
                </lib-input-text>

                <lib-input-secret [formControl]="loginForm.controls.Password"
                    [errorMessages]="passwordError"
                    [showRequiredIndicator]="false"
                    [isOptional]="false"
                    data-clarity-mask="true">
                    <ng-container label i18n="@@CommonPassword">
                        Password
                    </ng-container>
                </lib-input-secret>

            <lib-button
                [kind]="ButtonKind.Link"
                [disabled]="loginForm.disabled && !isViewOnly"
                [isViewOnly]="isViewOnly"
                [size]="ButtonSize.Large"
                (clicked)="Forgot()">
                <ng-container label i18n="@@LoginWidgetForgotPasswordButton">Forgot Password?</ng-container>
            </lib-button>

            <lib-divider></lib-divider>

            <lib-checkbox [formControl]="loginForm.controls.PublicComputer" i18n="@@LoginWidgetUsingPublicSharedDeviceLabel">
                I am using a public or shared device
            </lib-checkbox>
        </form>

        <lib-submission-bar
            [kind]="SubmissionBarKind.WidgetBasic">
            <lib-button class="scss-widget-primary-btn-accent-color"
            [role]="ButtonRole.Primary"
                #loginButton
                [kind]="ButtonKind.Primary"
                [stretch]="true"
                [loading]="loginForm.disabled && !isViewOnly"
                [isViewOnly]="isViewOnly"
                [size]="ButtonSize.Large"
                (clicked)="LoginButton()"
                (pressed)="DisableButton(loginButton)">
                <ng-container label i18n="@@CommonLoginButton">Log in</ng-container>
            </lib-button>
        </lib-submission-bar>

        @if (Scope.websiteMode === WebsiteMode.Live) {
            <lib-recaptcha
                [mode]="RecaptchaMode.Copyright">
            </lib-recaptcha>
        }
    }

    <lib-recaptcha #recaptcha
        [isWidgetVisible]="Scope.websiteMode === WebsiteMode.Live"
        [mode]="RecaptchaMode.Widget"
        (handleCaptcha)="HandleCAPTCHA()"
        (handleCaptchaError)="HandleCAPTCHAError()">
    </lib-recaptcha>

    <!-- ================================================ -->
    <!-- #RP Reset Password -->
    <!-- ================================================ -->
    @if (loginFormMode === LoginFormMode.ForgotPassword) {
        <h1 [ngClass]="{'align-self-center': true}" class="mb-2 scss-website-block-customized-heading-font"
            i18n="@@LoginWidgetResetPasswordTitle">
            Reset Password
        </h1>

        <p class="text-center py-3 scss-website-block-customized-body-font" i18n="@@LoginWidgetResetPasswordMessage">
            Please enter the email address of your account, and we will send you instructions to reset your password.
        </p>

        <form [formGroup]="resetPasswordForm">
                <lib-input-text [formControl]="resetPasswordForm.controls.EmailAddress"
                    [maxCharacterLength]="190"
                    [errorMessages]="emailError"
                    [isOptional]="false"
                    [showRequiredIndicator]="false"
                    data-clarity-mask="true">
                    <ng-container label i18n="@@CommonEmail">
                        Email
                    </ng-container>
                </lib-input-text>
        </form>

        <div class="d-flex flex-column w-100 pt-2">
            <lib-button
                class="scss-widget-primary-btn-accent-color"
                [kind]="ButtonKind.Primary"
                [stretch]="true"
                [loading]="resetPasswordForm.disabled && !isViewOnly"
                [isViewOnly]="isViewOnly"
                [size]="ButtonSize.Large"
                (clicked)="ResetPasswordButton()">
                <ng-container label i18n="@@CommonLoginWidgetRequestResetLink">Request reset link</ng-container>
            </lib-button>
        </div>

        <div class="d-flex w-100 pt-3 login-widget-link-btn"
            [ngClass]="{
            'justify-content-center': !isMobile,
            'flex-row': !isMobile,
            'flex-column': isMobile
            }">
            <div>
                <lib-button
                    [kind]="ButtonKind.Link"
                    [stretch]="true"
                    [disabled]="resetPasswordForm.disabled && !isViewOnly"
                    [isViewOnly]="isViewOnly"
                    [size]="ButtonSize.Large"
                    (clicked)="Normal()">
                    <ng-container label i18n="@@CommonLoginWidgetBackToLogin">Back to Login</ng-container>
                </lib-button>
            </div>
        </div>

        @if (Scope.websiteMode === WebsiteMode.Live) {
            <lib-recaptcha
                [mode]="RecaptchaMode.Copyright">
            </lib-recaptcha>
        }
    }

    <!-- ================================================ -->
    <!-- #RPTY Reset Password Thank You-->
    <!-- ================================================ -->
    @if (loginFormMode === LoginFormMode.ResetPasswordThankYou) {
        <h1 [ngClass]="{'align-self-center': true}" class="mb-2 scss-website-block-customized-heading-font"
            i18n="@@LoginWidgetResetPasswordTitle">
            Reset Password
        </h1>

        <p class="text-center py-3 scss-website-block-customized-body-font" i18n="@@LoginWidgetResetPasswordSentMessage">
            We sent a password reset link to the email associated with your account. If you don't see an email within the next 5 minutes, please check your spam or junk folder.
        </p>

        <div class="d-flex w-100 pt-2 login-widget-link-btn"
            [ngClass]="{
            'justify-content-center': !isMobile,
            'flex-row': !isMobile,
            'flex-column': isMobile
            }">

            <div>
                <lib-button
                    [kind]="ButtonKind.Link"
                    [stretch]="true"
                    [isViewOnly]="isViewOnly"
                    [size]="ButtonSize.Large"
                    (clicked)="Normal()">
                    <ng-container label i18n="@@CommonLoginWidgetBackToLogin">Back to Login</ng-container>
                </lib-button>
            </div>
        </div>
    }

    <!-- ================================================ -->
    <!-- #SA Select Account -->
    <!-- ================================================ -->
    @if (loginFormMode === LoginFormMode.MultipleJWTs) {
        <h1 [ngClass]="{'align-self-center': true}" class="mb-2 scss-website-block-customized-heading-font"
            i18n="@@LoginWidgetSelectAccountTitle">
            Select Account
        </h1>

        <p class="text-center py-3 scss-website-block-customized-body-font" i18n="@@CommonLoginWidgetPleaseSelectAccountMessage">
            Your email address is associated with multiple accounts. Please choose the account you wish to use for this session.
        </p>

        <form [formGroup]="multipleAccountSelectionForm">
            <lib-input-select
                [formControl]="multipleAccountSelectionForm.controls.AccountSelection"
                placeholderText="Select an account"
                [errorMessages]="continueError"
                identifyBy="ProfileID"
                nameBy="SchoolName"
                [showRequiredIndicator]="false"
                [isOptional]="false">
                <ng-container label i18n="@@CommonLoginWidgetAccount">
                    Account
                </ng-container>
                <lib-input-select-item *ngFor="let account of availableAccounts"
                    [value]="account">
                    <!-- //init it to the index of option, as string because 0 = false for a value. -->
                    <ng-container>
                        <!-- TODO: need to break out for translations -->
                        <!-- TODO: New Design once Widgets are restricted to per school. -->
                        {{account.FirstName}} {{account.LastName}}, {{account.ProfileMode}} at {{ account.SchoolName }}
                    </ng-container>
                </lib-input-select-item>
            </lib-input-select>
        </form>

        <div class="d-flex flex-column w-100 pt-2">
            <lib-button #continueButton
                class="scss-widget-primary-btn-accent-color"
                [kind]="ButtonKind.Primary"
                [stretch]="true"
                [loading]="multipleAccountSelectionForm.disabled && !isViewOnly"
                [disabled]="multipleAccountSelectionForm.disabled && !isViewOnly"
                [isViewOnly]="isViewOnly"
                [size]="ButtonSize.Large"
                (clicked)="Continue()"
                (pressed)="DisableButton(continueButton)">
                <ng-container label i18n="@@CommonContinueButton">Continue</ng-container>
            </lib-button>
        </div>

        <div class="d-flex w-100 pt-3 login-widget-link-btn"
            [ngClass]="{
            'justify-content-center': !isMobile,
            'flex-row': !isMobile,
            'flex-column': isMobile
            }">

            <div>
                <lib-button
                    [kind]="ButtonKind.Link"
                    [stretch]="true"
                    [disabled]="multipleAccountSelectionForm.disabled && !isViewOnly"
                    [isViewOnly]="isViewOnly"
                    [size]="ButtonSize.Large"
                    (clicked)="Normal()">
                    <ng-container label i18n="@@CommonLoginWidgetUseAnotherEmail">Use Another Email</ng-container>
                </lib-button>
            </div>
        </div>
    }

    <!-- ================================================ -->
    <!-- #2SV 2-Step Verification -->
    <!-- ================================================ -->
    @if (loginFormMode === LoginFormMode.MfaRequired || loginFormMode === LoginFormMode.OtpRequired) {
        <h1
            [ngClass]="{ 'align-self-center': true }"
            class="mb-2 scss-website-block-customized-heading-font"
            i18n="@@CommonWelcomeBackExclamationMarkTitle">
            Welcome back!
        </h1>

        @if (loginFormMode === LoginFormMode.MfaRequired) {
            <p
                class="text-center py-3 scss-website-block-customized-body-font"
                i18n="@@CommonTwoFactorAuthenticationEnter6DigitCode">
                Your account requires additional verification. Please check your <b>authenticator app</b> and enter the 6-digit code below:
            </p>
        } @else {
            <p
                class="text-center py-3 scss-website-block-customized-body-font"
                i18n="@@CommonTwoFactorAuthenticationEnter6DigitCodeFromEmail">
                Your account requires additional verification. Please check your <b>email</b> and enter the 6-digit code below:
            </p>
        }

        <lib-mfa-input [formControl]="mfaForm.controls.Code"></lib-mfa-input>

        <div class="d-flex flex-column w-100 pt-4">
            <lib-button #continueMFAButton
                class="scss-widget-primary-btn-accent-color"
                [kind]="ButtonKind.Primary"
                [stretch]="true"
                [loading]="mfaForm.disabled && !isViewOnly"
                [disabled]="mfaForm.disabled && !isViewOnly"
                [isViewOnly]="isViewOnly"
                [size]="ButtonSize.Large"
                (clicked)="ContinueMFA()"
                (pressed)="DisableButton(continueMFAButton)">
                <ng-container label i18n="@@CommonContinueButton">Continue</ng-container>
            </lib-button>
        </div>

        <div class="d-flex w-100 pt-3 login-widget-link-btn"
            [ngClass]="{
            'justify-content-center': !isMobile,
            'flex-row': !isMobile,
            'flex-column': isMobile
            }">

            <div>
                <lib-button
                    [kind]="ButtonKind.Link"
                    [stretch]="true"
                    [disabled]="mfaForm.disabled && !isViewOnly"
                    [isViewOnly]="isViewOnly"
                    [size]="ButtonSize.Large"
                    (clicked)="Normal()">
                    <ng-container label i18n="@@CommonCancel">Cancel</ng-container>
                </lib-button>
            </div>
        </div>
    }

    <!-- ================================================ -->
    <!-- #MR Manual Redirect -->
    <!-- ================================================ -->
    @if (loginFormMode === LoginFormMode.ManualRedirect) {
        <h1 [ngClass]="{'align-self-center': true}" class="mb-2 scss-website-block-customized-heading-font"
            i18n="@@LoginWidgetPortalLoginTitle">
            Portal Login
        </h1>

        <p class="text-center pt-3 scss-website-block-customized-body-font" i18n="@@LoginWidgetLoginManualRedirect">
            You are logged in. Click "Continue" if you were not automatically redirected.
        </p>

        <div class="d-flex flex-column w-100 pt-4">
            <lib-button
                class="scss-widget-primary-btn-accent-color"
                [kind]="ButtonKind.Primary"
                [stretch]="true"
                [size]="ButtonSize.Large"
                (clicked)="RedirectToTargetURL(manualRedirectJWT)">
                <ng-container label i18n="@@CommonContinueButton">Continue</ng-container>
            </lib-button>
        </div>
    }
</ng-template>